import useModelManagementHook from "../hooks/useModelManagementHook";

const ModelManagementFilter = () => {
  const { handler } = useModelManagementHook();

  const handleNewModelClick = () => {
    handler.handleResetAddPopup();
    handler.handleOpenModal('new');
  };

  return (
    <div className="page-header-title">
      <h5 className="m-b-10">Model Management</h5>
      <div>
        <button className="btn btn-primary btn-sm" onClick={handleNewModelClick}>
          <i className="fa fa-plus"></i> New Model
        </button>
      </div>
    </div>
  );
};

export default ModelManagementFilter;
